
import { Question } from '../types';

export const qur101CharacteristicsQuestions: Question[] = [
  {
    id: 'qur041',
    text: 'How might a Makki surah that has "Oh believers" be explained?',
    type: 'single',
    options: [
      { id: 'a', text: 'It\'s likely a misclassification and should be Madani', isCorrect: false },
      { id: 'b', text: 'It could be addressing the few believers who existed in Makkah', isCorrect: true },
      { id: 'c', text: 'It\'s likely a fabricated addition to the Qur\'ān', isCorrect: false },
      { id: 'd', text: 'It must have been added after the conquest of Makkah', isCorrect: false }
    ],
    explanation: 'If a Makki surah contains "Oh believers" (typically a Madani characteristic), it is likely addressing the small community of believers who existed during the Makkan period. This doesn\'t change its classification as Makki, which is based on when and where the majority of the surah was revealed.',
    topic: 'qur101'
  },
  {
    id: 'qur042',
    text: 'Which of the following is an exception to the general characteristics of Makki and Madani surahs?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Sūrat al-Qaṣas was revealed during the hijrah journey', isCorrect: true },
      { id: 'b', text: 'Sūrat al-Ḥajj contains a sajdah despite being Madani', isCorrect: true },
      { id: 'c', text: 'Sūrat al-Raʿd starts with Makki characteristics but transitions to Madani', isCorrect: true },
      { id: 'd', text: 'Some verses revealed in Makkah are considered Madani because of their time period', isCorrect: true }
    ],
    explanation: 'Several exceptions exist to the general Makki/Madani classifications: Sūrat al-Qaṣas was revealed during the hijrah journey; Sūrat al-Ḥajj contains a sajdah despite being Madani (when sajdahs are typically a Makki characteristic); Sūrat al-Raʿd starts with Makki characteristics but transitions to Madani; and some verses revealed physically in Makkah (e.g., during the conquest) are still considered Madani because of their time period.',
    topic: 'qur101'
  },
  {
    id: 'qur043',
    text: 'What was the focus of purification in Makki revelations?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Purification of belief and understanding of morality', isCorrect: true },
      { id: 'b', text: 'Correcting the idea that morality was dictated by government rather than Allāh', isCorrect: true },
      { id: 'c', text: 'Addressing impurities in belief (like worship of idols, confusion about Jesus, etc.)', isCorrect: true },
      { id: 'd', text: 'Establishing specific ritual purification rules', isCorrect: false }
    ],
    explanation: 'In Makki revelations, the focus of purification was on: purifying belief and understanding of morality; correcting the idea that morality was dictated by government rather than Allāh; and addressing impurities in belief, such as the Quraysh\'s worship of idols, confusion about who Jesus was, Jewish worship of Uzair, and fire worship. Specific ritual purification rules came later in Madani revelations.',
    topic: 'qur101'
  },
  {
    id: 'qur044',
    text: 'What pre-Islamic practices were addressed and corrected in Makki revelations?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Killing baby daughters', isCorrect: true },
      { id: 'b', text: 'Unfair trade practices based on tribal status', isCorrect: true },
      { id: 'c', text: 'Worship of idols', isCorrect: true },
      { id: 'd', text: 'Inheritance laws that treated women as property', isCorrect: true },
      { id: 'e', text: 'Specific prayer times and methods', isCorrect: false }
    ],
    explanation: 'Makki revelations addressed several pre-Islamic practices: killing baby daughters; unfair trade practices where affluent tribes could dictate prices and payment methods to less affluent ones; worship of idols by the Quraysh; and treatment of women as property to be inherited. Specific religious practices like prayer times came later in Madani revelations.',
    topic: 'qur101'
  },
  {
    id: 'qur045',
    text: 'What approaches does the Qur\'ān use to call people to Allāh in Makki surahs?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Verses that call people to observe what is around them', isCorrect: true },
      { id: 'b', text: 'Phrases like "Afalā taʿqilūn" (Will you not use reason?)', isCorrect: true },
      { id: 'c', text: 'Demonstration of the linguistic excellence of the Qur\'ān', isCorrect: true },
      { id: 'd', text: 'Providing specific legal punishments for disbelief', isCorrect: false }
    ],
    explanation: 'In Makki surahs, the Qur\'ān calls people to Allāh through: verses that invite people to observe what is around them in creation; phrases like "Afalā taʿqilūn" (Will you not use reason?); and demonstration of the linguistic excellence of the Qur\'ān over anything the Arabs could produce, proving its divine origin. The Qur\'ān provides different ways for people to connect because Allāh knows everyone is affected differently by different approaches.',
    topic: 'qur101'
  },
  {
    id: 'qur046',
    text: 'What was special about the Arabs that made the linguistic miracle of the Qur\'ān particularly effective?',
    type: 'single',
    options: [
      { id: 'a', text: 'They were the best poets and linguists of the era', isCorrect: true },
      { id: 'b', text: 'They had no written language before Islam', isCorrect: false },
      { id: 'c', text: 'They had never been exposed to religious texts', isCorrect: false },
      { id: 'd', text: 'They were more spiritual than other cultures', isCorrect: false }
    ],
    explanation: 'The linguistic miracle of the Qur\'ān was particularly effective with the Arabs because they were the best poets and linguists of the era. The Qur\'ān\'s perfection linguistically in all its meanings (prose, construction, words, consistency, beauty) reigned over anything the Arabs could produce, proving its divine origin to people who prided themselves on their linguistic abilities.',
    topic: 'qur101'
  },
  {
    id: 'qur047',
    text: 'What are ḥurūf muqaṭṭaʿāt in the Qur\'ān?',
    type: 'single',
    options: [
      { id: 'a', text: 'Disconnected letters at the beginning of some surahs (e.g., الم, كهيعص)', isCorrect: true },
      { id: 'b', text: 'The dots used to distinguish similar Arabic letters', isCorrect: false },
      { id: 'c', text: 'The vowel markings added in later manuscripts', isCorrect: false },
      { id: 'd', text: 'Special symbols indicating where to perform sajdah', isCorrect: false }
    ],
    explanation: 'Ḥurūf muqaṭṭaʿāt are the disconnected letters found at the beginning of some surahs of the Qur\'ān, such as الم (Alif Lam Mim), كهيعص (Kaf Ha Ya \'Ayn Sad), and الر (Alif Lam Ra). Their exact meaning is considered known only to Allāh, though scholars have offered various interpretations.',
    topic: 'qur101'
  },
  {
    id: 'qur048',
    text: 'What characteristics distinguish Madani surahs in terms of their content about belief?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Clear discussions of Jews and Christians', isCorrect: true },
      { id: 'b', text: 'Exposure of hypocrites', isCorrect: true },
      { id: 'c', text: 'Detailed rules about systems and laws', isCorrect: true },
      { id: 'd', text: 'Focus on correcting fundamental monotheistic beliefs', isCorrect: false }
    ],
    explanation: 'Madani surahs address belief differently from Makki surahs: they contain clear discussions about Jews and Christians; they expose hypocrites (who didn\'t exist in the Makki period as there were no perks to being Muslim then); and they provide detailed rules about systems and laws. The focus on correcting fundamental monotheistic beliefs was more characteristic of Makki surahs.',
    topic: 'qur101'
  },
  {
    id: 'qur049',
    text: 'Why were there no hypocrites during the Makki period according to Islamic history?',
    type: 'single',
    options: [
      { id: 'a', text: 'There were no perks to being Muslim then; only hardship', isCorrect: true },
      { id: 'b', text: 'The Quraysh prevented anyone from falsely claiming Islam', isCorrect: false },
      { id: 'c', text: 'The Prophet ﷺ could immediately identify anyone insincere', isCorrect: false },
      { id: 'd', text: 'The community was too small for hypocrites to hide', isCorrect: false }
    ],
    explanation: 'There were no hypocrites during the Makki period because there were no perks to being Muslim then—only hardship, persecution, and social ostracism. In Madinah, however, Muslims gained power and there were benefits to identifying as Muslim (no taxes, preference for zakāt distribution from baitul māl, etc.), which attracted some insincere converts.',
    topic: 'qur101'
  },
  {
    id: 'qur050',
    text: 'What types of legal matters are primarily addressed in Madani surahs?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Muʿāmalāt (civil interactions)', isCorrect: true },
      { id: 'b', text: 'Marriage and divorce', isCorrect: true },
      { id: 'c', text: 'Punishments for crimes', isCorrect: true },
      { id: 'd', text: 'Rules of inheritance', isCorrect: true },
      { id: 'e', text: 'Basic monotheistic beliefs', isCorrect: false }
    ],
    explanation: 'Madani surahs primarily address legal matters such as: muʿāmalāt (civil interactions and transactions); marriage and divorce; punishments for crimes; and detailed rules of inheritance. Basic monotheistic beliefs were primarily established earlier in Makki revelations.',
    topic: 'qur101'
  }
];
